import { Alert, Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { clearDraftPurchasesCache, CreatePurchaseStep, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { SecondaryButton } from "../Common/SecondaryButton";

export const ResumePurchaseBanner = () => {
    const history = useHistory<{ isAddingItem?: boolean } | null>();
    const resetState = useCreatePurchaseStore((state) => state.actions.resetState);

    const showResumePurchaseBanner = useCreatePurchaseStore((state) => {
        return state.purchase.items.length > 0;
    });

    const handleResume = () => {
        let resumeUrl;
        const packageId = useCreatePurchaseStore.getState().getPurchasePackageId();
        const isVariableDemographicsPackage = useCreatePurchaseStore.getState().isVariableDemographicsPackage();
        const isOneStepCheckout = useCreatePurchaseStore.getState().isOneStepCheckout();

        if (packageId && !isVariableDemographicsPackage) {
            useCreatePurchaseStore.setState({ step: CreatePurchaseStep.CHECKOUT });
            resumeUrl = `/cart`;
        } else {
            useCreatePurchaseStore.setState({
                step: isOneStepCheckout ? CreatePurchaseStep.CHECKOUT : CreatePurchaseStep.SELECT_DATE,
            });
            resumeUrl = `/cart`;
        }

        history.push(resumeUrl);
    };

    const handleDismiss = () => {
        resetState();
    };

    if (!showResumePurchaseBanner) {
        return null;
    }

    return (
        <div className="mt-10">
            <Alert color="primary">
                <div className="flex flex-row items-center justify-between p-2">
                    <div>
                        <div className="text-md">
                            <b>Resume Purchase</b>
                        </div>
                        <div className="mt-1 text-base">
                            It looks like you have items in your cart you have not purchased yet.
                        </div>
                    </div>
                    <div>
                        <div className="flex space-x-2">
                            <SecondaryButton
                                size="small"
                                onClick={() => {
                                    // Clear draft purchases cache since we don't need it if the purchase is dismissed.
                                    clearDraftPurchasesCache();
                                    handleDismiss();
                                }}
                            >
                                Dismiss
                            </SecondaryButton>

                            <Button size="small" onClick={() => handleResume()}>
                                Resume
                            </Button>
                        </div>
                    </div>
                </div>
            </Alert>
        </div>
    );
};
